import { DIV, NODISPLAY } from 'sdi/components/elements';
import { renderIndexSidebar } from 'qa/src/components/sidebar/index';
import map from './map';
import table from './table';
import { getLayout, getTheme } from 'qa/src/queries/app';
import { cancelButton } from './buttons';
import { tr } from 'sdi/locale';
import { deselectLinkedGroup } from '../events/qa';
import { getLastSelectedIssue } from '../queries/qa';
import { navigateMapAndTable, navigateToSelection } from '../events/route';
import { renderGlobalFilters } from './global-filter';

const renderMapLayout = () =>
    DIV(
        { className: 'content__wrapper' },
        renderGlobalFilters(),
        map(),
        NODISPLAY()
    );
const renderTableLayout = () =>
    DIV(
        { className: 'content__wrapper' },
        NODISPLAY(),
        renderGlobalFilters(),
        table()
    );
const renderMapAndTableLayout = () =>
    DIV(
        { className: 'content__wrapper' },
        renderGlobalFilters(),
        map(),
        table()
    );
const renderTableSelectLayout = () =>
    DIV(
        { className: 'content__wrapper add-link' },
        NODISPLAY(),
        DIV(
            {},
            DIV(
                { className: 'addLink-header' },
                DIV({ className: 'helptext' }, tr.qa('addLinkedIssueHelptext')),
                cancelButton(() => {
                    deselectLinkedGroup();
                    // setLinkChangeId(linkGroupId);
                    getTheme().map(theme =>
                        getLastSelectedIssue().foldL(
                            () => navigateMapAndTable(theme),
                            issue => navigateToSelection(theme, issue.id)
                        )
                    );
                })
            )
        ),
        table()
    );

const content = () => {
    switch (getLayout()) {
        case 'index':
        case 'mapAndTable':
        default:
            return renderMapAndTableLayout();
        case 'map':
            return renderMapLayout();
        case 'table':
            return renderTableLayout();
        case 'tableSelect':
            return renderTableSelectLayout();
    }
};
export const renderMain = () =>
    DIV(
        { className: 'index__wrapper main-and-right-sidebar' },
        content(),
        renderIndexSidebar()
    );

export default renderMain;
